<template>
    <g
        id="crossHair"
    >
        <line
            v-bind="{
                id : 'crossHair-horizLine',
                x1 : mousePos.x - size,
                y1 : mousePos.y,
                x2 : mousePos.x + size,   
                y2 : mousePos.y,
            }" 
        />

        <line
            v-bind="{
                id : 'crossHair-vertLine',
                x1 : mousePos.x,
                y1 : mousePos.y - size,
                x2 : mousePos.x,   
                y2 : mousePos.y + size,
            }" 
        />

    </g>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { gConsts } from '@/globals/gConsts';

// =========================================================================================

export default {
    name : 'crossHairCMP',
    props: {
        mousePos : {
            type : Object,
            default : () => ({ x: 0, y: 0 }),
            required : true
        }
    },

    data () {
        return {
            size : 3000,
            gConsts : gConsts
        }
    },

    computed: {
    },

    methods: {
    },
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
#crossHair {
    stroke: red;
    stroke-width: calc(1 / var(--wa-zoom-scale));
    stroke-dasharray: calc(6 / var(--wa-zoom-scale)) calc(4 / var(--wa-zoom-scale));
}
</style>